import axios from 'axios'
import config from '@/../config/ui-api'

const httpClient = axios.create({
  baseURL: `${config.baseEndpoint}/`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const apiClient = axios.create({
  ...httpClient.defaults,
  baseURL: `${config.apiEndpoint}/`,
})

export {
  apiClient,
  httpClient,
}
